/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedbeforeno2Inputs */

const en__field_participatedbeforeno2 = /** @type {(inputs: _Field_Participatedbeforeno2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const de__field_participatedbeforeno2 = /** @type {(inputs: _Field_Participatedbeforeno2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {_Field_Participatedbeforeno2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedbeforeno2 = /** @type {((inputs?: _Field_Participatedbeforeno2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedbeforeno2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participatedbeforeno2(inputs)
	return de__field_participatedbeforeno2(inputs)
});
export { _field_participatedbeforeno2 as "_field_participatedBeforeNo" }